import { render, staticRenderFns } from "./select-person.vue?vue&type=template&id=4d6a326e&"
import script from "./select-person.vue?vue&type=script&lang=js&"
export * from "./select-person.vue?vue&type=script&lang=js&"
import style0 from "./select-person.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports